import React from 'react';
import PropTypes from 'prop-types';
import { Route, useHistory } from 'react-router-dom';

import NetworkCheckBody from '../NetworkCheckBody/NetworkCheckBody';
import Graf from './parts/Graf/Graf';
import Rules from './parts/Rules/Rules';

const NetworkBody = ({
  selectId,
  hasNtcRules,
  customerId,
  setShowProgressBar,
  isGrafBlocked
}) => {
  const history = useHistory();
  let newUrl = history.location.pathname.split('/');
  newUrl.pop();
  newUrl = newUrl.join('/');

  return (
    <>
      <NetworkCheckBody hasNtcRules={hasNtcRules} />
      <Route path={`${newUrl}/network`}>
        <Graf
          selectId={selectId}
          customerId={customerId}
          setShowProgressBar={setShowProgressBar}
          isGrafBlocked={isGrafBlocked}
        />
      </Route>
      <Route path={`${newUrl}/firewall`}>
        <Rules networkId={selectId} />
      </Route>
    </>
  );
};

NetworkBody.propTypes = {
  selectId: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  hasNtcRules: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  customerId: PropTypes.string,
  isGrafBlocked: PropTypes.bool,
  setShowProgressBar: PropTypes.func
};

export default NetworkBody;
